module.exports = __webpack_public_path__ + "img/Фигура_13.svg?2940743f8d4bdea749af0fdba3beae5f";